import { instance } from "../api-instance";

export const AdditionalQuestionsApi = {
  getAdditionalQuestions(): Promise<unknown> {
    return instance.get("additionalQuestion/get").then((res) => res.data);
  },

  setAdditionalQuestions(values: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/save", values)
      .then((res) => res.data);
  },

  getAdditionalQuestionsDictionary(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getDictionary")
      .then((res) => res.data);
  },

  saveRepresentative(data: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/saveRepresentative", data)
      .then((res) => res.data);
  },

  saveBeneficiary(data: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/saveBeneficiary", data)
      .then((res) => res.data);
  },

  saveBeneficiaryOwner(data: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/saveBeneficiarOwner", data)
      .then((res) => res.data);
  },

  savePublicOfficial(data: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/saveContactPublicOfficialAffiliation", data)
      .then((res) => res.data);
  },

  saveRelative(data: unknown): Promise<unknown> {
    return instance
      .post("additionalQuestion/saveRelative", data)
      .then((res) => res.data);
  },

  getRepresentative(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getRepresentative")
      .then((res) => res.data);
  },

  getBeneficiary(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getBeneficiary")
      .then((res) => res.data);
  },

  getBeneficiaryOwner(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getBeneficiaryOwner")
      .then((res) => res.data);
  },

  getRelative(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getRelative")
      .then((res) => res.data);
  },

  getPublicOfficial(): Promise<unknown> {
    return instance
      .get("additionalQuestion/getContactPublicOfficialAffiliation")
      .then((res) => res.data);
  },

  removeRepresentative(): Promise<unknown> {
    return instance
      .get("additionalQuestion/removeRepresentative")
      .then((res) => res.data);
  },

  removeBeneficiary(): Promise<unknown> {
    return instance
      .get("additionalQuestion/removeBeneficiary")
      .then((res) => res.data);
  },

  removeBeneficiaryOwner(): Promise<unknown> {
    return instance
      .get("additionalQuestion/removeBeneficiaryOwner")
      .then((res) => res.data);
  },

  removeRelative(): Promise<unknown> {
    return instance
      .get("additionalQuestion/removeRelative")
      .then((res) => res.data);
  },

  removePublicOfficial(): Promise<unknown> {
    return instance
      .get("additionalQuestion/removeContactPublicOfficialAffiliation")
      .then((res) => res.data);
  },
};
